import { BasePreAuthenticationConfig } from '@/services/auth/call-with-auth/base'

/**
 * ユーザーセッションは生きているが現在ユーザーの情報が欠落している、というケースで欠落分を再取得する.
 * @see https://github.com/my-color/front/issues/3544
 */
export class PreRehashCurrentUserData extends BasePreAuthenticationConfig {
  readonly id: string = 'rehash auth'

  processable(): boolean {
    return this.authStateStore.hasAccessToken() && !this.authStateStore.hasUserId()
  }

  cascadeOn(_error: unknown): boolean {
    return false
  }

  process(): Promise<void> {
    return this.authGateway.rehash().then(result => result.fold(
      this.throwOnFail('fail to rehash current user data'),
      this.onSuccess('success to rehash current user data')
    ))
  }
}
